import { FieldType, FormFieldState } from '@studio/atomic-ui'
import { isDateRange } from 'react-day-picker'
import { format } from 'date-fns'
import { transformTime } from './get-hours'

/** BFF expects "YYYY-MM-DD HH:mm:ss" for date fields — do not use ISO 8601 (see crm-service.dto.ts) */
const formatLeadDate = (date: Date) => format(date, 'yyyy-MM-dd HH:mm:ss')

export const formatLeadRequestValue = (value: FieldType): string | number | boolean => {
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return value
  }

  if (typeof value === 'undefined') {
    return ''
  }

  if (value instanceof Date) {
    return formatLeadDate(value)
  }

  if (isDateRange(value)) {
    return value.from && value.to ? `${formatLeadDate(value.from)}; ${formatLeadDate(value.to)}` : ''
  }

  if ('value' in value) {
    return value.value
  }

  return transformTime(value.timeslot)
}

export const formatLeadRequest = (
  s: FormFieldState,
  submissionType: string
): Record<string, string | number | boolean> =>
  Object.entries(s).reduce(
    (finalRequest, [fieldName, fieldState]) =>
      fieldName.includes('[')
        ? finalRequest
        : { [fieldName.toLowerCase()]: formatLeadRequestValue(fieldState.value), ...finalRequest },
    { submissionType }
  )
